export default __webpack_public_path__ + "static/6i-5758fad3ea9da5806d502c34a842fc75.woff2";